import React from 'react'

const Mobile_Area_Start = () => {
  return (
    <div>
           <section class="mobile-app-area py-100 rel z-1">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-5">
                        <div class="mobile-app-content rmb-55" data-aos="fade-left" data-aos-duration="1500" data-aos-offset="50">
                            <div class="section-title mb-30">
                                <h2 className='work'>We Are Available On the Store Get Our Mobile Apps Very Easily</h2>
                            </div>
                            <p style={{color:'white'}}>We go above and beyond to make your travel dreams a reality. Trust us to handle the details so you can creating unforgettable memories. Explore the world with confidence</p>
                            <ul class="list-style-two mt-35 mb-30">
                                <li className='work'>Experience Agency</li>
                                <li className='work'>Professional Team</li>
                                <li className='work'>Low Cost Travel</li>
                                <li className='work'>Online Support 24/7</li>
                            </ul>
                            <div class="google-play-app-store">
                                <a href="#"><img src="assets/images/mobile-app/g-play.jpg" alt="Google Play"/></a>
                                <a href="#"><img src="assets/images/mobile-app/a-store.jpg" alt="App Store"/></a>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-7">
                        <div class="mobile-app-images">
                            <div class="bg"><img src="assets/images/mobile-app/phone-bg.png" alt="BG"/></div>
                            <div class="images">
                                <img src="https://images.pexels.com/photos/4657738/pexels-photo-4657738.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Phone" data-aos="fade-down-left" data-aos-duration="1500" data-aos-offset="50"/>
                                <img src="https://images.pexels.com/photos/3689276/pexels-photo-3689276.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Phone"/>
                                <img src="https://images.pexels.com/photos/4549416/pexels-photo-4549416.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Phone" data-aos="fade-up-right" data-aos-duration="1500" data-aos-offset="50"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
  )
}

export default Mobile_Area_Start
